/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'app/AppStore';
import { useFetchEasyBasketOperationDetails } from 'domains/easyBasket/EasyBasket.requests';
import { getEasyBasketOperation, getEasyBasketSelectedOperationId } from 'domains/easyBasket/EasyBasket.store';
import OperationHeader from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/common/OperationHeader';
import LaborTimesSelectionGroups from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/LaborTimesSelection/LaborTimesSelectionGroups';

const LaborTimesSelection = () => {
  const operationId = useSelector((state: RootState) => getEasyBasketSelectedOperationId(state));
  const operation = useSelector((state: RootState) => getEasyBasketOperation(state, operationId));
  const operationDetail = useFetchEasyBasketOperationDetails(operationId);
  const laborTimes = operationDetail?.basketContent.laborTimeSection.laborTimeItems;

  return (
    <>
      <OperationHeader title={operation?.data?.designation ?? ''} />
      <LaborTimesSelectionGroups laborTimesGroups={laborTimes ?? []} />
    </>
  );
};

export default LaborTimesSelection;
